<script lang="ts">
    import {
        sendCurrentDictionaryAnalyticsEvent,
        sendUIInteractionAnalyticsEvent,
    } from "@app/services/analytics/analytics-send-event";
    import AddExampleForm from "./AddExampleForm.svelte";

    function init() {
        const activators = [
            ...document.querySelectorAll<HTMLElement>(".add-example-inline"),
        ];

        activators.forEach((activator) => {
            let addTranslationForm = null;
            if (!activator) {
                return;
            }
            const tmemContainer = document.querySelector<HTMLElement>(
                "#add-example-inline-container"
            );

            if (!tmemContainer) {
                return;
            }

            function toggleAddTranslationForm(event: Event) {
                event.preventDefault();
                const isOpen =
                    tmemContainer.dataset["open"] === "true" || false;
                addTranslationForm = (tmemContainer as any).addTranslationForm;

                if (!addTranslationForm) {
                    (tmemContainer as any).addTranslationForm =
                        new AddExampleForm({
                            target: tmemContainer,
                            props: {
                                onClose: toggleAddTranslationForm,
                            },
                        });
                }
                addTranslationForm = (tmemContainer as any).addTranslationForm;

                const newIsOpen = !isOpen;
                tmemContainer.dataset["open"] = `${newIsOpen}`;
                setTimeout(() => {
                    if (newIsOpen) {
                        const scrollY =
                            tmemContainer.parentElement.offsetTop -
                            document.getElementById("search-container")
                                .offsetHeight;
                        window.scrollTo({
                            left: 0,
                            top: scrollY,
                            behavior: "smooth",
                        });
                    }
                    sendUIInteractionAnalyticsEvent({
                        action: "expand-add-example",
                        label: newIsOpen ? "open" : "close",
                    });
                }, 10);
                addTranslationForm.$set({ open: newIsOpen });
            }
            activator.addEventListener("click", toggleAddTranslationForm);
        });
    }

    init();
</script>
